import React, { ReactElement, useState } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import SledovanyLegislativnyMaterialList from '../../../module/LegislativnyMaterial/SledovanyLegislativnyMaterialList';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import { useUserContext } from '../../../context/UserContext';
import { pouzivatelIsPrihlaseny } from '../../../function/permissions';
import SuccessMessages from '../../../module/SuccessMessages';

const SledovanyLegislativnyMaterialListPage = (): ReactElement => {
  const [pageStatus, setPageStatus] = useState<number>(null);
  const { pouzivatel } = useUserContext();

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.procesy.sledovane,
          heading: 'Sledované procesy',
        },
      ]}
      />
      <GlobalErrors />
      <SecuredPage additionalCheck={pouzivatelIsPrihlaseny(pouzivatel)} requestStatus={pageStatus}>
        <>
          <SuccessMessages />
          <PageHeadingWithBackButton heading="Sledované legislatívne procesy" />
          <SledovanyLegislativnyMaterialList setPageStatus={setPageStatus} />
        </>
      </SecuredPage>
    </Layout>
  );
};

export default SledovanyLegislativnyMaterialListPage;
